'use client';

import React from 'react';
import { Theme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { SxProps } from '@mui/system/styleFunctionSx';
import { BlockContainer } from '@/components/Blocks/BlockContainer';
import { CmsBlock } from '@/components/Blocks/CmsBlock';
import { BlockTitle } from '@/components/Blocks/components/BlockTitle';
import { CmsBlock as CmsBlockData } from '@/services/cms/blocks';
import { CmsBaseBlock } from '@/services/cms/blocks/BaseCmsBlock';
import { CmsMultiColumnBlock } from '@/services/cms/blocks/CmsMultiColumnBlock';

export type MultiColumnBlockProps = {
    sx?: SxProps<Theme>;
} & CmsMultiColumnBlock;

export const MultiColumnBlock = ({ sx, ...props }: MultiColumnBlockProps) => (
    <BlockContainer sx={sx} {...props}>
        <BlockTitle {...props} />
        <Grid container spacing={2}>
            {(props.elements?.elements as CmsBaseBlock[])?.map((block, i) => (
                <Grid
                    key={`cms-block-column-${block.id}`}
                    size={{
                        xs: 12,
                        sm: props.columnSize
                    }}>
                    <CmsBlock position={i} isSubBlock={true} key={`cms-block-${block.id}`} data={block as CmsBlockData} />
                </Grid>
            ))}
        </Grid>
    </BlockContainer>
);
